export const PLAYING = 'Video.Playing'
export const PAUSED = 'Video.Paused'
export const STOPPED = 'Video.Stopped'
export const LOADING = 'Video.Loading'

export default {
    PLAYING,
    PAUSED,
    STOPPED,
    LOADING,
}

// TODO : after implementation of new VideoPlayer
// TODO   validate the use-case of the "LOADING"
// TODO   state
